import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import SiteProofLogo from '../../../components/SiteProofLogo';
import { useLanguage } from '../../../contexts/LanguageContext';

const RegistrationHeader = () => {
  const { t } = useLanguage();

  return (
    <div className="text-center lg:text-left space-y-3 md:space-y-4">
      <div className="flex items-center justify-center lg:justify-start gap-3">
        <SiteProofLogo size="lg" />
      </div>

      <div className="space-y-2">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground font-heading">
          {t('reg.create_account')}
        </h2>
        <p className="text-sm md:text-base text-muted-foreground max-w-2xl mx-auto lg:mx-0">
          {t('reg.subtitle')}
        </p>
      </div>

      <div className="flex items-center justify-center lg:justify-start gap-2 text-sm text-muted-foreground">
        <Icon name="Clock" size={16} />
        <span className="font-caption">{t('reg.time_estimate')}</span>
      </div>

      <div className="pt-2">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm md:text-base text-accent hover:text-accent/80 transition-smooth font-medium"
        >
          <Icon name="ArrowLeft" size={18} />
          <span>{t('reg.already_have_account')}</span>
        </Link>
      </div>
    </div>
  );
};

export default RegistrationHeader;